import {Flex, Text} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";

const NoCover = ({size = '317px', h = '317px', minH = '317px', title, padding = 0}) => {
    const {t} = useTranslation("default");

    return <Flex
        align="center"
        justify="center"
        w={{base: "100%", md: size}}
        h={{base: "100%", md: h ?? size}}
        minW={{base: "100%", md: size}}
        minH={{base: minH, md: "100%"}}
        bg="gray.200"
        color="gray.600"
        fontFamily="Poppins"
        fontSize="16px"
        fontWeight="500"
        textAlign="center"
        p={padding}
    >
        <Text>
            {title || t('event.no_cover')}
        </Text>
    </Flex>
}
export default NoCover;
